import React from 'react';
import cx from 'classnames';
import Link from 'next/link';
import { PRODUCT } from 'routes';

import { Modal } from 'components/Modal';
import Typography from 'components/Typography';
import useWindowSize from 'hooks/useWindowSize';
import { Product } from 'types/Product';
import { makeDevImgSrc, stringifyMultipleDesigners } from 'utils';
import styles from './ProductTagTooltip.module.css';

export const BOX_SIZE = 320;

interface ProductTagTooltipProps {
  product: Product;
  onClose?: (() => void) | boolean;
  translateX?: string;
  open?: boolean;
}

const ProductTagTooltip: React.FCWithChildren<ProductTagTooltipProps> = ({
  product,
  onClose,
  translateX,
  open = false,
}) => {
  const { browse_thumb, slug } = product;
  const thumb = makeDevImgSrc(browse_thumb || '');
  const ref = React.useRef<HTMLDivElement | null>(null);

  const windowSize = useWindowSize();
  const { breakpoints } = windowSize;

  const isTabletUp = breakpoints['tablet-portrait-up'];

  const Wrapper: React.FCWithChildren = ({ children }) =>
    isTabletUp ? (
      <Link
        passHref
        href={{ pathname: PRODUCT.pathname, query: { id: slug } }}
        className={cx(styles.root, open && styles.open)}
        style={{ transform: translateX && `translateX(${translateX})`, width: BOX_SIZE }}
      >
        {children}
      </Link>
    ) : (
      <Modal
        className={cx(styles.root, open && styles.open)}
        position="bottom"
        onClose={typeof onClose === 'function' ? onClose : undefined}
      >
        <Link passHref href={{ pathname: PRODUCT.pathname, query: { id: slug } }}>
          {children}
        </Link>
      </Modal>
    );

  return (
    <Wrapper>
      <div ref={ref} className={styles.productTagTooltip}>
        <div className={styles.productTagTooltipImage}>
          <img alt={product.name} src={thumb} />
        </div>

        <div className={styles.productTagTooltipContent}>
          <Typography block uppercase>
            {product.name}
          </Typography>
          <Typography block uppercase color="faded">
            {stringifyMultipleDesigners(product.designers)}
          </Typography>
        </div>
      </div>
    </Wrapper>
  );
};
export default ProductTagTooltip;
